import React, { useState, useContext, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import FlagIcon from "../../images/flagus.png";
import Image from "react-bootstrap/Image";
import Logo from "../../images/logocolor.png";
import { AuthContext } from "../../../utility/services/AuthContext";
import Functions from "../../../utility/services/Functions";
import ApiService from "../../../utility/services/ApiService";
import { ValidationsService } from "../../../utility/services/ValidationsService";
import { toast } from "react-toastify";
import ReactLoader from "react-js-loader";

const Otp_model = (props) => {
  const verify_type = props.verify_type;
  const ProfileUpdate = verify_type == "update_profile";
  const NumberUpdate = verify_type == "number_update";

  const { consoleService, set_user_details, set_patient_user_details } =
    Functions();
  const {
    update_contact_number,
    confirm_otp_for_update_number,
    send_otp,
    check_duplicate_number_for_update_number,
  } = ApiService();
  const { user, authUserRole } = useContext(AuthContext);
  const [validationsRes, setValidationsRes] = useState({});

  const userDetails = user.details;
  const IsTherapist = authUserRole == "Therapist";
  const old_phone_auth_key = "old_phone";
  const new_phone_auth_key = "new_phone";

  const [phone, setPhone] = useState(userDetails.phone);
  const [new_phone, setNewPhone] = useState("");
  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  const [showOtpFields, setShowOtpFields] = useState(false);
  const [showPhoneInput, setShowPhoneInput] = useState(false);
  const [confirm_type, setConfirmType] = useState(old_phone_auth_key);
  const [otp_loading, setOtpLoading] = useState(false);
  const [resend_code_loading, setResendCodeLoading] = useState(false);
  const [initial_loading, setInitialLoading] = useState(false);

  const otp = otpValues.join("");

  useEffect(() => {
    validationsResFun();
  }, [new_phone]);

  useEffect(() => {
    sendOtpFun(phone);
  }, []);

  async function sendOtpFun(phone) {
    try {
      setInitialLoading(true);
      if (phone) {
        await send_otp({ phone, role: authUserRole });
        setShowOtpFields(true);
        setInitialLoading(false);
      } else {
        setShowPhoneInput(true);
        setInitialLoading(false);
      }
    } catch (err) {
      setInitialLoading(false);
      consoleService("error in sendOtpFun =  ", err);
    }
  }
  function validationsResFun() {
    setValidationsRes(ValidationsService({ phone: new_phone }));
  }

  const handleInputChange = (index, value) => {
    const ModifiedValue = value.replace(/[^0-9]/g, "");
    const newOtpValues = [...otpValues];
    newOtpValues[index] = ModifiedValue;
    setOtpValues(newOtpValues);

    // Auto-focus on the next input
    if (ModifiedValue !== "" && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Move to the previous input on backspace
    if (e.key === "Backspace" && index > 0 && otpValues[index] === "") {
      inputRefs[index - 1].current.focus();
    }
  };

  const resend_otp_function = async (e) => {
    try {
      e.preventDefault();
      setResendCodeLoading(true);
      await send_otp({ phone, role: authUserRole });
      clear_otp_input();
      setResendCodeLoading(false);
      toast("Otp Sent Successfully.", {
        position: "top-center",
        hideProgressBar: true,
        type: "success",
      });
    } catch (err) {
      consoleService("error in resend otp function", err);
    }
  };

  const clear_otp_input = () => {
    setOtpValues(["", "", "", ""]);
  };

  const handle_update_number = async (confirm_type) => {
    try {
      const isConfirmPhoneTypeOld = confirm_type == old_phone_auth_key;
      const isConfimPhoneTypeNew = confirm_type == new_phone_auth_key;

      if (isConfirmPhoneTypeOld) {
        const otp_auth_res = await confirm_otp_for_update_number({ otp });
        if (otp_auth_res.status === 1) {
          setShowOtpFields(false);
          clear_otp_input();
          setShowPhoneInput(true);
        } else if (otp_auth_res.status === 5) {
          setShowOtpFields(false);
          clear_otp_input();
        } else {
          toast(otp_auth_res.message, {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      } else if (isConfimPhoneTypeNew) {
        const otp_auth_res = await update_contact_number({ phone, otp });
        if (otp_auth_res.status === 1) {
          setShowPhoneInput(false);
          setShowOtpFields(false);
          clear_otp_input();
          IsTherapist ? set_user_details() : set_patient_user_details();
          toast("Number Updated Successfully.", {
            position: "top-center",
            hideProgressBar: true,
            type: "success",
          });
          props.onHide();
        } else {
          toast(otp_auth_res.message, {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
        }
      }

      setOtpLoading(false);
    } catch (err) {
      consoleService("error in handle_update_number = ", err);
    }
  };

  const handle_update_profile = async () => {
    props.handle_profile_update(otp, setOtpLoading);
  };

  const submit_otp_fun = async (confirm_type) => {
    setOtpLoading(true);
    try {
      if (NumberUpdate) {
        handle_update_number(confirm_type);
      } else if (ProfileUpdate) {
        handle_update_profile();
      }
    } catch (err) {
      setOtpLoading(false);
      consoleService("error in submit_otp_fun", err);
    }
  };

  const submit_new_number = async () => {
    setOtpLoading(true);
    try {
      const modifiedPhone = `+1${new_phone.trim()}`;
      const duplicate_check_res =
        await check_duplicate_number_for_update_number({
          phone: modifiedPhone,
        });
      if (!(duplicate_check_res.status === 1)) {
        setOtpLoading(false);
        return toast(duplicate_check_res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }

      await sendOtpFun(modifiedPhone);
      setPhone(modifiedPhone);
      setShowOtpFields(true);
      setShowPhoneInput(false);
      setConfirmType(new_phone_auth_key);
      setOtpLoading(false);
    } catch (err) {
      setOtpLoading(false);
      consoleService("error insubmit_new_number", err);
    }
  };

  const OtpInputs = (confirm_type) => {
    return (
      <Modal.Body className="otp_model_container">
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <Form>
                  <div
                    className="loginBox loginOtpBox my-0"
                    style={{ boxShadow: "none" }}
                  >
                    <div className="text-center">
                      <Link to="">
                        <Image src={Logo} className="logo" alt="" />
                      </Link>
                      <h1>Enter OTP</h1>
                      <p>Enter the OTP sent to the number provided by you</p>
                    </div>
                    <h4>
                      OTP has been sent to <span>{phone}</span>
                    </h4>
                    <div className="formOtp mb-3">
                      {otpValues.map((value, index) => (
                        <Form.Group
                          key={index}
                          controlId={`exampleForm.ControlInput${index}`}
                        >
                          <Form.Control
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]"
                            maxLength={1}
                            placeholder=""
                            value={value}
                            onChange={(e) =>
                              handleInputChange(index, e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key == "Enter") {
                                otp.length == 4 && submit_otp_fun(confirm_type);
                              } else {
                                handleKeyDown(index, e);
                              }
                            }}
                            ref={inputRefs[index]}
                          />
                        </Form.Group>
                      ))}
                    </div>
                    <Link
                      className="conguest"
                      onClick={(e) => {
                        resend_otp_function(e);
                      }}
                    >
                      {resend_code_loading ? (
                        <ReactLoader
                          type="bubble-loop"
                          bgColor={"#1D7E7C"}
                          size={40}
                        />
                      ) : (
                        "Resend Code"
                      )}
                    </Link>
                    <Button
                      disabled={otp.length !== 4}
                      onClick={() => {
                        submit_otp_fun(confirm_type);
                      }}
                      className="btn btn-primary-no-hover otp_sub_btn "
                    >
                      {otp_loading ? (
                        <ReactLoader type="bubble-loop" size={40} />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </Modal.Body>
    );
  };

  const MobileInputField = () => {
    return (
      <Modal.Body className="otp_model_container">
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <Form>
                  <div
                    className="loginBox loginOtpBox otp_model_phone_input_container my-0"
                    style={{ boxShadow: "none" }}
                  >
                    <div className="text-center">
                      <Link to="">
                        <Image src={Logo} className="logo" alt="" />
                      </Link>
                      <h1>Enter New Phone Number</h1>
                      <p className="mb-5">
                        You are about to update your phone number to a new one.
                        Please confirm that the number you enter is correct.
                      </p>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput2"
                      >
                        <div className="pbox">
                          <div className="callb">
                            US{" "}
                            <svg
                              width="12"
                              height="8"
                              viewBox="0 0 12 8"
                              fill="none"
                              x
                            >
                              <path
                                d="M1 1.5L6 6.5L11 1.5"
                                stroke="#212529"
                                stroke-width="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <span
                              style={{
                                color: !new_phone.trim() ? "#929fa4" : null,
                              }}
                            >
                              +1
                            </span>
                          </div>
                          <Form.Control
                            type="text"
                            value={new_phone}
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                              setNewPhone(numericValue);
                            }}
                            onKeyDown={(e) => {
                              if (e.key == "Enter") {
                                e.preventDefault();
                                !validationsRes.phoneErr && submit_new_number();
                              }
                            }}
                            placeholder="(555) 000-0000"
                          />
                        </div>
                      </Form.Group>
                    </div>

                    <Button
                      disabled={validationsRes.phoneErr}
                      className="btn btn-primary-no-hover otp_sub_btn mt-5"
                      onClick={() => {
                        submit_new_number();
                      }}
                    >
                      {otp_loading ? (
                        <ReactLoader
                          type="bubble-loop"
                          bgColor={"white"}
                          size={40}
                        />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </Modal.Body>
    );
  };

  return (
    <Modal
      {...props}
      size="md"
      className="modalSuccess"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {initial_loading ? (
        <Modal.Body className="text-center py-5">
          <ReactLoader
            type="bubble-loop"
            bgColor={"#1D7E7C"}
            size={60}
          />
        </Modal.Body>
      ) : (
        <>
          {showOtpFields && OtpInputs(confirm_type)}
          {showPhoneInput && MobileInputField()}
        </>
      )}
    </Modal>
  );
};

export default Otp_model;
